module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading || _vm.loadingUser) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', [_c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleJoinDialog),
      callback: function($$v) {
        _vm.toggleJoinDialog = $$v
      },
      expression: "toggleJoinDialog"
    }
  }, [_c('h3', [_vm._v("Join SK Club")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-checkbox', {
    staticClass: "checkbox--light-input",
    attrs: {
      "label": "I want to join SK Club now",
      "value": "termsChecked"
    },
    model: {
      value: (_vm.termsChecked),
      callback: function($$v) {
        _vm.termsChecked = $$v
      },
      expression: "termsChecked"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-tooltip', {
    key: "join-tooltip",
    attrs: {
      "content": "SK Club roles out the red carpet for those who are serious about experiencing movies the best way possible! Join the SK Club now to unlock great discounts, earn points and get special treatment!"
    }
  })], 1)], 2), _vm._v(" "), _c('span', [_vm._v("By joining SK Club, you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("SK Club Ts & Cs")])]), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "disabled": !_vm.termsChecked,
      "loading": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        _vm.joinSkClub()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "disabled": _vm.loadingDelete
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleJoinDialog = false
      }
    }
  }, [_vm._v("No")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleActivateDialog),
      callback: function($$v) {
        _vm.toggleActivateDialog = $$v
      },
      expression: "toggleActivateDialog"
    }
  }, [_c('h3', [_vm._v("Activate your account")]), _vm._v(" "), _c('hr'), _vm._v("\n            Please activate your account before attempting to join Sk Club\n            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleActivateDialog = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDeleteAccountPrompt),
      callback: function($$v) {
        _vm.toggleDeleteAccountPrompt = $$v
      },
      expression: "toggleDeleteAccountPrompt"
    }
  }, [_c('h3', [_vm._v("Are you sure?")]), _vm._v(" "), _c('hr'), _vm._v("\n            Are you sure you want to delete your account?\n            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleDeleteAccountPrompt = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.doDeleteAccount()
      }
    }
  }, [_vm._v("Yes")])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-header"
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "welcome-message"
  }, [_c('h2', {
    staticClass: "profile-heading"
  }, [(_vm.isUsersBirthday) ? [_vm._v("\n                                    Happy Birthday " + _vm._s(_vm.loggedInUser.FirstName) + "! Enjoy a movie on us for your Birthday\n                                ")] : [_vm._v("\n                                    Hi " + _vm._s(_vm.loggedInUser.FirstName) + "! Welcome To Your Dashboard\n                                ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('sk-icon', {
    attrs: {
      "email": ""
    }
  }), _vm._v("\n                                " + _vm._s(_vm.loggedInUser.Email) + " "), _c('br'), _vm._v(" "), (_vm.loggedInUser.CardNumber != undefined && _vm.loggedInUser.CardNumber != null) ? [(_vm.loggedInUser.CardNumber.length > 0) ? _c('span', [_vm._v("SK Club card number: " + _vm._s(_vm.loggedInUser.CardNumber))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm.showUserActivation) ? _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#dddee0"
    }
  }, [_vm._v("\n                                Thanks for creating an SK profile! Please activate your account by checking your email for your verification link. Haven't received it? "), _c('sk-button', {
    staticClass: "btn--reactivate",
    attrs: {
      "link": "",
      "loading": _vm.activationLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resendVerification()
      }
    }
  }, [_vm._v("Resend the verification email now")]), _vm._v(".\n                            ")], 1) : _vm._e()])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "view-profile"
  }, [_c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.profile = !_vm.profile;
        _vm.managePayment = !_vm.profile
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), ((_vm.loggedInUser.PreferenceList.includes(5) || _vm.loggedInUser.PreferenceList.includes(6)) && (_vm.loggedInUser.WorkZipCode != undefined && _vm.loggedInUser.WorkZipCode != null)) ? _c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.managePayment = !_vm.managePayment;
        _vm.profile = !_vm.managePayment
      }
    }
  }, [_vm._v("Manage Payments")]) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-content-body"
  }, [_c('div', {
    staticClass: "profile-content-body--wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.profile) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "profile-content"
  }, [_c('sk-form', {
    staticClass: "profile-form",
    attrs: {
      "id": "user-signup-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('sk-panel', [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Personal Details"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-icon', {
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.profile = false
      }
    }
  })], 1)], 2), _vm._v(" "), _c('p', {
    staticClass: "manditory-fields"
  }, [_vm._v("All Fields are manditory")]), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-input', {
    staticClass: "dark-input",
    attrs: {
      "value": "",
      "label": "First Name",
      "placeholder": "John",
      "name": "fname",
      "autocomplete": "given-name",
      "prepend": ""
    },
    model: {
      value: (_vm.loggedInUser.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "FirstName", $$v)
      },
      expression: "loggedInUser.FirstName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "value": "",
      "label": "Surname",
      "placeholder": "Doe",
      "name": "lname",
      "autocomplete": "family-name"
    },
    model: {
      value: (_vm.loggedInUser.LastName),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "LastName", $$v)
      },
      expression: "loggedInUser.LastName"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "radio-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "gender-label",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Female",
      "label": "Female"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Male",
      "label": "Male"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Unknown",
      "label": "I'd rather not say"
    },
    model: {
      value: (_vm.loggedInUser.Gender),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "Gender", $$v)
      },
      expression: "loggedInUser.Gender"
    }
  })], 1)], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Household Size")]), _vm._v(" "), _c('sk-select', {
    attrs: {
      "placeholder": "Household Size",
      "type": "number"
    },
    model: {
      value: (_vm.loggedInUser.PersonsInHousehold),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "PersonsInHousehold", $$v)
      },
      expression: "loggedInUser.PersonsInHousehold"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Household Size")]), _vm._v(" "), _vm._l((10), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  })], 2)], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Contact Details"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-input', {
    attrs: {
      "label": "Email",
      "value": "",
      "placeholder": "e.g. xxx@gmail.com",
      "autocomplete": "email",
      "name": "email",
      "type": "email",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.changedEmail),
      callback: function($$v) {
        _vm.changedEmail = $$v
      },
      expression: "changedEmail"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Mobile Number",
      "autocomplete": "tel",
      "name": "mobile",
      "placeholder": "eg. +27827804800",
      "type": "tel",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}$"
    },
    model: {
      value: (_vm.loggedInUser.MobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "MobilePhone", $$v)
      },
      expression: "loggedInUser.MobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-panel', {
    staticClass: "form"
  }, [_c('sk-title-heading', {
    attrs: {
      "h3": "",
      "label": "Your Movie Preferences"
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Make this my default cinema")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-cinema form--inline"
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.preferences.place_query),
      callback: function($$v) {
        _vm.$set(_vm.preferences, "place_query", $$v)
      },
      expression: "preferences.place_query"
    }
  }), _vm._v(" "), _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemasByRegion,
      "group-values": "cinemas",
      "group-label": "name",
      "track-by": "id",
      "search": _vm.search,
      "label": "name",
      "searchable": true,
      "placeholder": "Choose a cinema",
      "multiple": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.$groupLabel) ? [_vm._v("\n                                                        " + _vm._s(props.option.$groupLabel) + "\n                                                    ")] : [_c('span', {
          staticClass: "option__title",
          class: {
            'genres': props.option.loyalty_cinema_id
          }
        }, [_vm._v(_vm._s(props.option.name) + " "), (props.option.distance) ? [_vm._v("- " + _vm._s(props.option.distance) + "KM")] : _vm._e()], 2)]]
      }
    }]),
    model: {
      value: (_vm.loggedInUser.PreferredComplex),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "PreferredComplex", $$v)
      },
      expression: "loggedInUser.PreferredComplex"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("\n                                                    No cinema found, please try a different cinema\n                                                ")])], 2)], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prefered Genres")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "preferences__labels"
  }, _vm._l((_vm.genres), function(genre) {
    return _c('span', {
      key: genre.id,
      staticClass: "preferences__labels-item"
    }, [(_vm.loggedInUser.PreferredGenres.includes(parseInt(genre.id))) ? [_c('span', {
      staticClass: "label label--lg active",
      on: {
        "click": function($event) {
          _vm.selectGenre(genre, $event)
        }
      }
    }, [_vm._v(_vm._s(genre.name))])] : [_c('span', {
      staticClass: "label label--lg",
      on: {
        "click": function($event) {
          _vm.selectGenre(genre, $event)
        }
      }
    }, [_vm._v(_vm._s(genre.name))])]], 2)
  }))], 1), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Your Email Subscription Settings")]), _vm._v(" "), _c('hr', {
    staticClass: "hr--transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-form--wrapper"
  }, [_c('sk-checkbox', {
    staticClass: "checkbox--light newsletter__subscribe",
    attrs: {
      "id": "subscribe",
      "value": "subscribe",
      "label": "Subscibe me to the SK Newsletter"
    },
    model: {
      value: (_vm.loggedInUser.SendNewsletter),
      callback: function($$v) {
        _vm.$set(_vm.loggedInUser, "SendNewsletter", $$v)
      },
      expression: "loggedInUser.SendNewsletter"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n                                                     You'll get to enter our competitions first and receive invitations to exclusive events.\n                                                 ")])], 2)], 1)]), _vm._v(" "), (_vm.loggedInUser.PreferenceList.indexOf(5) !== -1 || _vm.loggedInUser.PreferenceList.indexOf(6) !== -1) ? _c('sk-panel', [_c('h3', [_vm._v("Your SK Subscription Club Settings")]), _vm._v(" "), _c('hr', {
    staticClass: "hr--transparent"
  }), _vm._v(" "), _c('sk-button', {
    staticStyle: {
      "margin-right": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "secondary": "",
      "disabled": !_vm.canCancelSub
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleCancelSubDialog = true
      }
    }
  }, [_vm._v("\n                                            Cancel Subscription\n                                        ")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleCardUpdate = true
      }
    }
  }, [_vm._v("Update Credit Card")]), _vm._v(" "), _c('p', [_vm._v("Please note that cancellations are immediate and benefits will be revoked.")]), _vm._v(" "), (!_vm.canCancelSub) ? _c('p', [_vm._v(_vm._s(_vm.canCancelSubErrorMessage))]) : _vm._e(), _vm._v(" "), (_vm.toggleCardUpdate) ? [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your New Card Details")]), _vm._v(" "), _c('p', [_vm._v("Please update your payment information")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "checkout",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('sk-form', {
    staticClass: "form",
    attrs: {
      "id": "checkout-form"
    },
    on: {
      "submit": function($event) {
        _vm.updateCardSubscription()
      }
    }
  }, [_c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardHolder",
      "autocomplete": "cardHolder",
      "label": "Cardholder Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the name on the card.'
      }
    },
    model: {
      value: (_vm.card.cardHolder),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardHolder", $$v)
      },
      expression: "card.cardHolder"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cardNumber",
      "type": "number",
      "label": "Credit Card Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your credit card number.'
      }
    },
    model: {
      value: (_vm.card.cardNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cardNumber", $$v)
      },
      expression: "card.cardNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Month",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryMonth),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryMonth", $$v)
      },
      expression: "card.expiryMonth"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Month")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return (month != undefined && month != null) ? _c('option', {
      domProps: {
        "value": month.value
      }
    }, [_vm._v(_vm._s(month.name))]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-select', {
    attrs: {
      "placeholder": "Year",
      "type": "number"
    },
    model: {
      value: (_vm.card.expiryYear),
      callback: function($$v) {
        _vm.$set(_vm.card, "expiryYear", $$v)
      },
      expression: "card.expiryYear"
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Expiry Year")]), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return (year != undefined && year != null) ? _c('option', {
      domProps: {
        "value": year.year
      }
    }, [_vm._v(_vm._s(year.year))]) : _vm._e()
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-input', {
    staticClass: "light-input",
    attrs: {
      "name": "cvvNumber",
      "type": "number",
      "autocomplete": "cvvNumber",
      "label": "CVV Number",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter the CVV number at the back of the card.'
      }
    },
    model: {
      value: (_vm.card.cvvNumber),
      callback: function($$v) {
        _vm.$set(_vm.card, "cvvNumber", $$v)
      },
      expression: "card.cvvNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "payment-info": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "text-right": ""
    }
  }, [_c('p', {
    staticClass: "text--small"
  }, [_vm._v("Ster-Kinekor is secure. For credit card payments we accept")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/visa.png",
      "alt": "Visa"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm6": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/master-card.png",
      "alt": "Master Card"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    class: _vm.$breakpoints.smDown ? 'text-right' : '',
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "payment-footer": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm10": "",
      "grow": "",
      "text-right": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleCardUpdate = false
      }
    }
  }, [_vm._v("Undo")])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "loading": _vm.loadingUpdateCard,
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('sk-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "frmLaunchACS",
    attrs: {
      "id": "frmLaunchACS",
      "name": "frmLaunchACS",
      "action": _vm.adumoCardUpdate.postURL,
      "method": "POST"
    }
  }, [_c('textarea', {
    attrs: {
      "id": "PaReq",
      "name": "PaReq"
    }
  }, [_vm._v(_vm._s(_vm.adumoCardUpdate.PaReq))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "TermUrl",
      "name": "TermUrl"
    },
    domProps: {
      "value": _vm.adumoCardUpdate.TermUrl
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "id": "MD",
      "name": "MD"
    },
    domProps: {
      "value": _vm.adumoCardUpdate.MD
    }
  })])], 1)] : _vm._e(), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleCancelSubDialog),
      callback: function($$v) {
        _vm.toggleCancelSubDialog = $$v
      },
      expression: "toggleCancelSubDialog"
    }
  }, [_c('h3', [_vm._v("Cancel your SK Subscription Club membership")]), _vm._v(" "), _c('hr'), _vm._v("\n                                            Are you sure you want to cancel your SK Subscription Club membership\n                                            "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": "",
      "loading": _vm.cancelSubLoading,
      "disabled": !_vm.canCancelSub,
      "contextValue": "Subscription Funnel",
      "dataValue": "Cancel Subscription"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelSubscription(_vm.loggedInUser.MemberId)
      }
    }
  }, [_vm._v("Cancel Subscription")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleCancelSubDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Change Password")]), _vm._v(" "), _c('sk-form', {
    staticClass: "change-password-form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("We'll send you a link to your email address to create a new password.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToResetPassword()
      }
    }
  }, [_vm._v("\n                                                Change My Password\n                                            ")])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h3', [_vm._v("Delete Loyalty Account")]), _vm._v(" "), _c('sk-form', {
    staticClass: "change-password-form",
    attrs: {
      "id": "user-password-reset-code-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.loggedInUser.PreferenceList.indexOf(5) !== -1 || _vm.loggedInUser.PreferenceList.indexOf(6) !== -1) ? [_c('p', [_vm._v("Please cancel your subscription club subscription before attempting to delete your account.")])] : [_c('p', [_vm._v("Would like to delete your account? Please note, this is permanent, and will lose all loyalty benefits.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDeleteAccountPrompt = true
      }
    }
  }, [_vm._v("\n                                                    Delete Account\n                                                ")])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-buttons"
  }, [_c('sk-button', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.profile = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.updateLoader
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveProfile()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.loggedInUser.PreferenceList.includes(5) && !_vm.loggedInUser.PreferenceList.includes(6)) ? _c('sk-panel', [_c('sk-layout', {
    staticClass: "subs-club-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("SK Subscription Club")]), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('p', [_vm._v("Join SK Subscription Club to get more than you paid for today!")]), _vm._v(" "), _c('p', [_vm._v("\n                                        As a SK Subscription Club member, you can get a subscription for a Limited or Unlimited \n                                        amount of movies per month at a set cost, which you pay per month. This means \n                                        you can now watch more movies at a lower price, whilst also enjoying the benefits \n                                        of the SK Club\n                                    ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps--join-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Join Now")])], 1)])])], 1)], 1) : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.loggedInUser.PreferenceList.includes(5)) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("SK MORvies CLUB")]), _c('br'), _c('br')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', [_vm._v("Watch more movies for less")]), _vm._v(" "), _c('p', [_vm._v("\n                                            Let's get going! You can watch up to 5 movies per day for free and claim 20% off on a medium soda and popcorn combo. You can use your eCard at the checkout to redeem both SK MORvies CLUB benefits and SK Club points and rewards.\n                                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                                            *T's & C's apply\n                                        ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps--join-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/type/Subs"
    }
  }, [_vm._v("Book now")])], 1)], 1)], 1) : [(_vm.loggedInUser.PreferenceList.includes(6)) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("SK FAN CLUB")]), _c('br'), _c('br')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', [_vm._v("Watch more movies for less")]), _vm._v(" "), _c('p', [_vm._v("\n                                                Let's get going! You can use all 4 tickets at once to start booking for you and your family. You can use your eCard at the checkout to redeem both SK FAN CLUB benefits and SK Club points and rewards.\n                                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                *T's & C's apply\n                                            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "sk-club__join-steps--join-btn",
    attrs: {
      "primary": "",
      "tag": "a",
      "href": "/type/Subs"
    }
  }, [_vm._v("Book now")])], 1)], 1)], 1) : _vm._e()]], 2), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard profile-subs-club-benefits",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("YOUR BENEFITS")]), _c('br'), _c('br')])], 1), _vm._v(" "), (_vm.loggedInUser.PreferenceList.includes(5)) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-30": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('sk-badge', {
    attrs: {
      "color": _vm.subsClubColour,
      "secondaryIcon": !_vm.subsClubSecondaryIcon
    }
  }, [_c('template', {
    slot: "front"
  }, [_c('div', {
    staticClass: "badge_icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/subs/ticket-active-icon.png"
    }
  })])]), _vm._v(" "), _c('template', {
    slot: "back"
  }, [_vm._v("\n                                                             \n                                                                ")]), _vm._v(" "), _c('template', {
    slot: "points"
  }, [_vm._v("Unlimited")])], 2)], 1), _vm._v(" "), (_vm.subsClubRenewDate != null && _vm.subsClubRenewDate != undefined) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("SUBSCRIPTION RENEWED ON")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.subsClubRenewDate.getDate()) + "/" + _vm._s(_vm.subsClubRenewDate.getMonth() + 1) + "/" + _vm._s(_vm.subsClubRenewDate.getFullYear()))])]) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "information",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("20% off a medium popcorn and soda combo")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Book now at any Cinema")])])], 1)] : [(_vm.loggedInUser.PreferenceList.includes(5)) ? [(_vm.rewards != undefined && _vm.rewards != null) ? [_vm._l((_vm.rewards), function(reward) {
    return (reward.Name.includes('Limited')) ? [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "gutter-30": ""
      }
    }, _vm._l((4), function(n) {
      return _c('sk-flex', {
        key: n,
        attrs: {
          "xs6": "",
          "sm6": "",
          "md3": ""
        }
      }, [(n <= reward.QtyAvailable) ? [_c('sk-badge', {
        attrs: {
          "color": _vm.subsClubColour,
          "secondaryIcon": !_vm.subsClubSecondaryIcon
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('div', {
        staticClass: "badge_icon"
      }, [_c('img', {
        attrs: {
          "src": "/static/img/subs/ticket-active-icon.png"
        }
      })])]), _vm._v(" "), _c('template', {
        slot: "back"
      }, [_vm._v(" \n                                                                    ")]), _vm._v(" "), _c('template', {
        slot: "points"
      }, [_vm._v("Movie " + _vm._s(n))])], 2)] : [_c('sk-badge', {
        staticClass: "claimed",
        class: _vm.subsClubInactiveColour,
        attrs: {
          "secondaryIcon": !_vm.subsClubSecondaryIcon
        }
      }, [_c('template', {
        slot: "front"
      }, [_c('div', {
        staticClass: "badge_icon"
      }, [_c('img', {
        attrs: {
          "src": "/static/img/subs/ticket-inactive-icon.png"
        }
      })])]), _vm._v(" "), _c('template', {
        slot: "back"
      }, [_vm._v(" \n                                                                    ")]), _vm._v(" "), _c('template', {
        slot: "points"
      }, [_vm._v("Movie " + _vm._s(n))])], 2)]], 2)
    }))] : _vm._e()
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "information",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("20% off a medium popcorn and soda combo")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("SUBSCRIPTION RENEWED ON")]), _vm._v(" "), _c('p')])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Book now at any Cinema")])])], 1)] : _vm._e()] : _vm._e()]], 2)], 1)], 1)], _vm._v(" "), (_vm.loggedInUser.MemberLevelId != 19) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md7": ""
    }
  }, [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Rewards")]), _vm._v(" "), _c('div', {
    staticClass: "profile-dashboard-rewards"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-30": ""
    }
  }, _vm._l((_vm.skBadges), function(badge) {
    return (badge.available == true) ? _c('sk-flex', {
      key: badge.title,
      attrs: {
        "xs6": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('sk-badge', {
      attrs: {
        "color": badge.color,
        "secondaryIcon": !badge.active
      }
    }, [_c('template', {
      slot: "front"
    }, [_c('sk-icon', {
      attrs: {
        "icon": badge.icon
      }
    })], 1), _vm._v(" "), _c('template', {
      slot: "back"
    }, [(badge.active) ? _c('a', {
      attrs: {
        "href": badge.redirect || '/',
        "data-track-context": "rewards",
        "data-track-value": badge.title
      }
    }, [_vm._v("Book\n                                                            Now")]) : _c('span', [_vm._v("No Reward Yet")])]), _vm._v(" "), _c('template', {
      slot: "points"
    }, [_vm._v(_vm._s(badge.title))]), _vm._v(" "), _c('template', {
      slot: "text"
    }, [_vm._v("\n                                                        " + _vm._s(badge.description) + "\n                                                        "), (badge.alt) ? [_c('br'), _vm._v(" "), _c('span', {
      staticClass: "text--small"
    }, [_vm._v(_vm._s(badge.alt))])] : _vm._e()], 2)], 2)], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": ""
    }
  }, [_c('h2', {
    staticClass: "profile-heading points-heading"
  }, [_vm._v("Your Points")]), _vm._v(" "), _c('div', {
    staticClass: "profile-dashboard-points"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "points-block-wrapper",
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "points-block"
  }, [_c('h4', {
    staticClass: "points-block--total-points"
  }, [_vm._v(_vm._s(_vm.loggedInUser.PointsBalance))]), _vm._v(" "), _c('h6', [_vm._v("your total points")])])]), _vm._v(" "), _c('sk-flex', {
    staticClass: "points-block-wrapper",
    attrs: {
      "xs6": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "points-block last"
  }, [_c('h4', {
    staticClass: "points-block--total-points next-points"
  }, [_vm._v("\n                                                        " + _vm._s(_vm.nextReward))]), _vm._v(" "), _c('h6', [_vm._v("points to your"), _c('br'), _vm._v("\n                                                        next reward")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "view-points"
  }, [_c('sk-button', {
    staticClass: "btn--link",
    attrs: {
      "tag": "a"
    },
    nativeOn: {
      "click": function($event) {
        _vm.togglePoints($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                                        Your Points Statement\n                                                    ")])], 1)])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Bookings")]), _vm._v(" "), (_vm.mostRecentBooking.MovieName) ? _c('div', {
    staticClass: "profile-dashboard-bookings"
  }, [_c('h4', {
    staticClass: "movie-name"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.MovieName))]), _vm._v(" "), _vm._l((_vm.mostRecentBooking.MovieSession.experiences), function(exp, index) {
    return _c('p', {
      key: index,
      staticClass: "experience"
    }, [_vm._v(_vm._s(exp.name))])
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_day_of_week))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_nth_day))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_month))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Time")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("Starts")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.BookingDate.additional.minute))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v(" Ends " + _vm._s(_vm.mostRecentBooking.EndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.EndDate.additional.minute))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('p', [_c('sk-icon', {
    attrs: {
      "location-pin": ""
    }
  }), _vm._v("\n                                        " + _vm._s(_vm.mostRecentBooking.CinemaName) + "\n                                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "view-all"
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.allBookings($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        See All Upcoming Bookings\n                                    ")])], 1)], 2) : _c('div', {
    staticClass: "profile-dashboard-bookings profile-dashboard-bookings--no-bookings"
  }, [_c('p', {
    staticClass: "text-grey text-bold--700"
  }, [_vm._v("No Upcoming Bookings")]), _vm._v(" "), _c('p', {
    staticClass: "text-grey text-bold--400"
  }, [_vm._v("Check out movies that are Now Showing and Coming Soon.")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "secondary": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("See all movies now")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-y-transition"
    }
  }, [(_vm.pointStatement) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-points', {
    attrs: {
      "user-points": _vm.loggedInUser.LifeTimePoints
    }
  }, [_c('sk-title-heading', {
    attrs: {
      "slot": "heading",
      "h2": "",
      "label": "Your Points Statement"
    },
    slot: "heading",
    model: {
      value: (_vm.h1Active),
      callback: function($$v) {
        _vm.h1Active = $$v
      },
      expression: "h1Active"
    }
  }, [_c('sk-icon', {
    attrs: {
      "slot": "append",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pointStatement = false
      }
    },
    slot: "append"
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showBookings) ? _c('sk-layout', {
    staticClass: "profile-dashboard",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', [_c('sk-title-heading', {
    staticClass: "title-heading",
    attrs: {
      "h2": !_vm.$breakpoints.xs,
      "h4": _vm.$breakpoints.xs,
      "label": "Your Bookings"
    },
    model: {
      value: (_vm.h1Active),
      callback: function($$v) {
        _vm.h1Active = $$v
      },
      expression: "h1Active"
    }
  }, [_c('sk-icon', {
    attrs: {
      "slot": "append",
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showBookings = false
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('sk-booking', {
    attrs: {
      "bookingHistory": _vm.BookingHistory
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "status"
    }
  }), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', [_vm._v("Your Status")]), _vm._v(" "), _c('sk-tiers', {
    attrs: {
      "percentage": _vm.tierMoviesPercentage,
      "is-vip": _vm.loggedInUser.isVip(),
      "to-go": _vm.tierMoviesToGo,
      "fill": "ffffff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cards"
    }
  }), _vm._v(" "), (_vm.loggedInUser) ? _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Cards")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-carousel', {
    staticClass: "club-carousel",
    attrs: {
      "pageMarkers": "",
      "slides-per-page": _vm.slidesPerPage,
      "wrap": false
    }
  }, [_c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-sk-club.png",
      "title": "SK Club",
      "loading": _vm.linkingSkClub,
      "type": "sk-club",
      "card-number": _vm.loggedInUser.CardNumber,
      "joined": _vm.loggedInUser.MemberLevelId != 19,
      "linked": _vm.loggedInUser.CardNumber != null
    },
    on: {
      "link": _vm.linkSkClub,
      "join": function($event) {
        _vm.toggleJoinDialog = true
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-vitality.png",
      "title": "Discovery Vitality",
      "type": "generic",
      "generic-message": "Need a Discovery Vitality SK digital Movie Card?",
      "more-info-link": "/club-loyalty/Discovery_Vitality#discovery-form"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-edgars-club.png",
      "title": "Edgars Club",
      "type": "generic",
      "generic-message": "Get movie and popcorn & soda benefits with Edgars Club.",
      "more-info-link": "https://edgarsclub.co.za/membership-options"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1)])], 1)], 1)], 1) : _vm._e()], 1)] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "cards"
    }
  }), _vm._v(" "), (_vm.loggedInUser) ? _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Cards")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-carousel', {
    staticClass: "club-carousel",
    attrs: {
      "pageMarkers": "",
      "slides-per-page": _vm.slidesPerPage
    }
  }, [_c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-sk-club.png",
      "title": "SK Club",
      "loading": _vm.linkingSkClub,
      "type": "sk-club",
      "card-number": _vm.loggedInUser.CardNumber,
      "joined": _vm.loggedInUser.MemberLevelId != 19,
      "linked": (_vm.loggedInUser.CardNumber != null)
    },
    on: {
      "link": _vm.linkSkClub,
      "join": _vm.checkSlClub
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-vitality.png",
      "title": "Discovery Vitality",
      "type": "generic",
      "generic-message": "Need a Discovery Vitality SK digital Movie Card?",
      "more-info-link": "/club-loyalty/Discovery_Vitality#discovery-form"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cards",
    attrs: {
      "slot": "slides"
    },
    slot: "slides"
  }, [_c('sk-card', {
    attrs: {
      "path": "/static/img/loyalty-edgars-club.png",
      "title": "Edgars Club",
      "type": "generic",
      "generic-message": "Get movie and popcorn & soda benefits with Edgars Club.",
      "more-info-link": "https://edgarsclub.co.za/membership-options"
    },
    on: {
      "link": _vm.linkCard
    }
  })], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    staticClass: "profile-dashboard",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('sk-panel', [_c('h2', {
    staticClass: "profile-heading"
  }, [_vm._v("Your Bookings")]), _vm._v(" "), (_vm.mostRecentBooking.MovieName) ? _c('div', {
    staticClass: "profile-dashboard-bookings"
  }, [_c('h4', {
    staticClass: "movie-name"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.MovieName))]), _vm._v(" "), _c('p', {
    staticClass: "experience"
  }, [_vm._v(_vm._s(_vm.mostRecentBooking.Movie.experiencesString))]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Date")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_day_of_week))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_nth_day))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.string_long_month))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', {
    staticClass: "schedule"
  }, [_vm._v("Time")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v("Starts")]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info--bold"
  }, [_vm._v("\n                                            " + _vm._s(_vm.mostRecentBooking.BookingDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.BookingDate.additional.minute))]), _vm._v(" "), _c('p', {
    staticClass: "schedule-info"
  }, [_vm._v(" Ends " + _vm._s(_vm.mostRecentBooking.EndDate.additional.no_zero_hour_24) + ":" + _vm._s(_vm.mostRecentBooking.EndDate.additional.minute))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('p', [_c('sk-icon', {
    attrs: {
      "location-pin": ""
    }
  }), _vm._v("\n                                        " + _vm._s(_vm.mostRecentBooking.CinemaName) + "\n                                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "view-all"
  }, [_c('sk-button', {
    attrs: {
      "link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.allBookings($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        View All Bookings\n                                    ")])], 1)], 1) : _c('div', {
    staticClass: "profile-dashboard-bookings profile-dashboard-bookings--no-bookings"
  }, [_c('p', {
    staticClass: "text-grey text-bold--500"
  }, [_vm._v("No Upcoming Bookings")]), _vm._v(" "), _c('p', {
    staticClass: "text-grey text-bold--400"
  }, [_vm._v("Check out movies that are Now Showing and Coming Soon.")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "block": "",
      "secondary": "",
      "router": "",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("See all movies now")])], 1)], 1)], 1)])], 1)], 1)], _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": _vm.relatedMoviesLabel
    }
  }) : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff0fe65a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/user/profile.vue
// module id = 562
// module chunks = 0